const $inject = ['$document', '$timeout', '$q'];

const toggleService = function ($document, $timeout, $q) {
  let service = {
    elements: [],
  };

  $document.bind('mousedown', (event) => {
    let isClickedElementChildOfPopup = false;
    let scope;

    angular.forEach(service.elements, (element) => {
      if (!isClickedElementChildOfPopup) {
        isClickedElementChildOfPopup = element[0].contains(event.target);
      }

      scope = element.pageScope;
    });

    if (!isClickedElementChildOfPopup) {
      angular.forEach(service[scope], (item, key) => {
        service[scope][key] = false;
      });

      $timeout(() => {
        service[scope] = service[scope];
      }, 0);
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
  });

  service.subscribe = function subscribe(scope, name, element) {
    element.pageScope = scope;
    service.elements.push(element);

    if (!service[scope]) {
      service[scope] = {};
    }
    service[scope][name] = false;
  };

  service.reset = function reset(scope) {
    delete service[scope];
    service.elements = [];
  };

  service.remove = function reset(scope, key) {
    if (service[scope]) {
      delete service[scope][key];
    }
  };

  service.toggle = function toggle(scope, name) {
    const deferred = $q.defer();

    angular.forEach(service[scope], (item, key) => {
      if (name == key) {
        service[scope][key] = !service[scope][key];
      } else {
        service[scope][key] = false;
      }
    });

    deferred.resolve(service[scope][name]);

    return deferred.promise;
  };

  return service;
};

toggleService.$inject = $inject;

export default toggleService;



// WEBPACK FOOTER //
// ./src/services/toggleService.js